import { SET_MOBILE_VIEW } from "./constants";

/**
 * SET mobile view
 */
export const setMobileView = (data) => {
  return (dispatch) => {
    dispatch({ type: SET_MOBILE_VIEW, data: data });
  };
};
